<script setup lang="ts">
const {fileUrl} = useFiles()

const properties = defineProps<{
  data: any
}>()

const imageClasses = computed(() => {
  return {
    'col-span-2 md:col-span-1 row-start-1 md:col-start-1':
      properties.data.image_position == 'left',
    'col-span-2 md:col-span-1 row-start-2 md:row-start-1 md:col-start-2':
      properties.data.image_position == 'right',
  }
})

const textClasses = computed(() => {
  return {
    'col-span-2 md:col-span-1 row-start-1 md:col-start-1':
      properties.data.image_position == 'right',
    'col-span-2 md:col-span-1 row-start-2 md:row-start-1 md:col-start-2':
      properties.data.image_position == 'left',
  }
})
</script>

<template>
  <div class="grid grid-cols-2 gap-8">
    <div></div>
    <div :class="imageClasses" class="overflow-hidden rounded-xl shadow">
      <NuxtImg
        :src="fileUrl(data.translations[0].image)"
        class="h-full w-full object-cover"
        crossorigin
        format="webp"
        v-if="data.translations[0].image"
      />
    </div>
    <div
      :class="textClasses"
      class="prose"
      v-html="data.translations[0].text"
    />
  </div>
</template>
